// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pages-video-index-list-obicw{display:grid;grid-gap:24px}.pages-video-index-list-obicw.pages-video-index-desktop-bltak{grid-template-columns:repeat(4,1fr)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list": "pages-video-index-list-obicw",
	"desktop": "pages-video-index-desktop-bltak"
};
module.exports = ___CSS_LOADER_EXPORT___;
